import { View } from 'backbone.marionette';
import Preloader from '../../../../utils/Preloader';
import Radio from 'backbone.radio';
import { redirectTo } from '../../../../utils';

const leagueLadderChannel = Radio.channel('league_ladder');

/**
 * @desc CoreLeagueLadderView Header Class
 * This class using on league loin page ('fantasy/league/ladder')
 */
export class CoreLadderHeader extends View {
	get className() {
		return "ladder-header";
	}

	ui() {
		return {
			change_ladder: '.js-change-ladder',
			change_round:  '.js-change-round',
			sort_column:   '.js-sort-column'
		};
	}

	events() {
		return {
			'click @ui.change_ladder': 'changeLadder',
			'change @ui.change_round': 'changeRound',
			'click @ui.sort_column': 'sortColumn'
		};
	}

	modelEvents() {
		return {
			'league:query:not:found': 'redirectToMyLeague',
		};
	}

	get defaultTemplateType() {
		return 'open';
	}

	async initialize() {
		this.league_id = this.getOption( 'league_id' );
		this.rounds = this.getOption( 'rounds' );

		this.model.set( {
			template_type: this.defaultTemplateType,
		} );

		Preloader.show();

		await this.fetchData();

		this.initListeners()
			.updateModel();

		Preloader.hide();
	}

	initListeners() {
		this.listenTo( this.model, 'change', this.render );

		return this;
	}

	changeLadder( element ) {
		let template_type = $(element.currentTarget).data('type');

		this.model.set( 'template_type', template_type );

		leagueLadderChannel.trigger( 'ladder:switch:table' );
	}

	changeRound( element ) {
		let current_round = $(element.currentTarget).val(),
			selected_round = current_round;

		current_round = current_round === '' ? this.rounds.points_round.get('id') : current_round;

		this.model.set( { current_round, selected_round } );
		leagueLadderChannel.trigger( 'ladder:update:round', selected_round );
	}

	fetchData() {
		return Promise.all( [
			this.model.setShowUrl().fetch(
				{
					data: {
						id: this.league_id
					}
				}
			),
			this.rounds.fetch()
		] );
	}

	updateModel() {
		this.checkCurrentUser();

		let league_type = this.model.get( 'type' ),
			template_type = ( league_type === 'open' ) ? 'open': 'h2h',
			is_on_bye_rounds = this.model.isOnByeRounds,
			is_final_on = this.model.is_final_on,
			rounds = this.rounds.recalculateCompleteRounds( is_on_bye_rounds );

		if (is_final_on) {
			rounds = rounds.filter(({ id }) => !this.model.isFinalRound(id));
		}

		this.current_round = this.model.isOnByeRounds ?
			this.rounds.points_round :
			this.rounds.activeRoundWithoutBye;

		this.model
			.set( {
				template_type,
				rounds,
				current_round: this.current_round.get('id')
			} )
			.setAvatar();

		leagueLadderChannel.trigger( 'ladder:update' );

		return this;
	}

	checkCurrentUser(){
		if( !this.model
			.checkLeagueMember() && !this.model.checkAccessToLeague()
		) {
			this.redirectToMyLeague();
		}
	}

	sortColumn( element ) {
		let order_direction = this.model.get( 'order_direction' );

		let data = {
			order:           $( element.currentTarget ).data( 'order' ),
			order_direction: order_direction === 'ASC' ? 'DESC' : 'ASC'
		};
		leagueLadderChannel.trigger( 'ladder:sort:update', data );
	}

	redirectToMyLeague() {
		redirectTo( '/fantasy/leagues' );
	}
}

export default CoreLadderHeader;